import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BASE_URL} from '../constants';
import {BrowseDocuments} from '../../models/browseDocuments.model';
import {map} from 'rxjs/operators';

export interface DocTypeToken {
  type: string;
  tokens: string[];
}

@Injectable({
  providedIn: 'root'
})
export class FileService {
  URL = BASE_URL + '/file/';
  constructor(private http: HttpClient) { }

  public upload(formData): Observable<any> {
    return this.http.post<any>(this.URL + 'upload/', formData,  {
      reportProgress: true,
      observe: 'events'
    });
  }

  public uploadDirectory(formData): Observable<any> {
    return this.http.post<any>(this.URL + 'upload_directory/', formData,  {
      reportProgress: true,
      observe: 'events'
    });
  }

  public uploadZipDirectory(formData): Observable<any> {
    return this.http.post<any>(this.URL + 'upload_zip_directory/', formData,  {
      reportProgress: true,
      observe: 'events'
    });
  }

  public get(status: string): Observable<BrowseDocuments> {
    let params = new HttpParams();
    params = params.append('status', status);
    return this.http.get<BrowseDocuments>(this.URL + 'get/', { params }).pipe(map(res => res));
  }

  public get_file(token: string): Observable<any> {
    return this.http.get<BrowseDocuments>(this.URL + 'get/' + token + '/').pipe(map(res => res));
  }

  public delete(docType: string, docId: string): Observable<any> {
    return this.http.post(this.URL + docType + '/' + docId + '/delete/', {});
  }

  public delete_files(docIds: string[]): Observable<any> {
    const params = {docIds};
    return this.http.post(this.URL + 'delete_files/', params);
  }

  public stopAnonymization(docType: string, docId: string): Observable<any> {
    const url = this.URL + 'stop_anonymization/' + docType + '/' + docId + '/';
    return this.http.post( url, {});
  }

  download(docIds: DocTypeToken[], queueId: string): Observable<any> {
    const params = {docIds, queue_id: queueId};
    return this.http.post(this.URL + 'download/', params, {observe: 'events', responseType: 'blob', reportProgress: true});
  }

  public getFileName(ext: string= 'zip', fileNumber?: number, allFiles?: number, ) {
    const date = new Date();
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    if (fileNumber !== undefined && allFiles !== undefined){
      return 'ShareMedix-' + y + (m <= 9 ? '0' + m : m) + (d <= 9 ? '0' + d : d) + '_' + fileNumber.toString() + '_of_' + allFiles.toString() + '.' + ext;
    }else {
      return 'ShareMedix-' + y + (m <= 9 ? '0' + m : m) + (d <= 9 ? '0' + d : d) + '.' + ext;
    }
  }

  public getFileExtensionForDownload(response){
    let ext = 'zip';
    switch (response) {
      case 'application/pdf': {
        ext = 'pdf';
        break;
      }

      case 'image/png': {
        ext = 'png';
        break;
      }
      case 'image/bmp': {
        ext = 'bmp';
        break;
      }

      case 'image/x-ms-bmp': {
        ext = 'bmp';
        break;
      }

      case 'image/webp': {
        ext = 'webp';
        break;
      }

      case 'image/jpeg': {
        ext = 'jpg';
        break;
      }

    }
    return ext;
  }

  getImage(imgSrc: string): Observable<any> {
    return this.http.get(imgSrc, { responseType: 'blob' as 'json'});
  }

}
